module.exports = __webpack_public_path__ + "static/media/2.8d4b7d8a.jpg";